module.exports = __webpack_public_path__ + "static/0006-1f9cf28f3ad925b22e7daad5bbc9fd5e.png";